/**
 * @name AllocationsTypes ActionTypes
 * @memberof module:common/actions
 * @type {ReduxAction}
 * @return {Object} Global Actions Types
 */
export const GET_ALLOCATION_COMPANY = 'GET_ALLOCATION_COMPANY';
export const SET_ALLOCATION_INFO = 'SET_ALLOCATION_INFO';
